<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>设施运维</el-breadcrumb-item>
        <el-breadcrumb-item>运维管理</el-breadcrumb-item>
        <el-breadcrumb-item>综合维保</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="工单ID">
                <el-input v-model="searchForm.TicketId" placeholder="请输入工单ID"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="activeTab === 'subMaintenanceDetail'">
              <el-form-item label="主单ID">
                <el-input v-model="searchForm.MainTicketId" placeholder="请输入主单ID"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="园区">
                <el-select clearable v-model="searchForm.CampusName" placeholder="请选择" style="width: 100%">
                  <el-option label="张家口-怀来瑞北" value="张家口-怀来瑞北"></el-option>
                  <el-option label="清远-清新" value="清远-清新"></el-option>
                  <el-option label="清远-清城" value="清远-清城"></el-option>
                  <el-option label="深圳-滨海腾大" value="深圳-滨海腾大"></el-option>
                  <el-option label="贵阳-贵安七星" value="贵阳-贵安七星"></el-option>
                  <el-option label="天津-滨海高新" value="天津-滨海高新"></el-option>
                  <el-option label="南京-江宁" value="南京-江宁"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计划开始">
                <el-date-picker
                  v-model="searchForm.createTime"
                  type="daterange"
                  range-separator="-"
                  style="width: 100%"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleDateChange"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-tabs v-model="activeTab" class="custom-tabs" @tab-click="handleTabClick">
      <el-tab-pane label="综合维保主单" name="maintenance">
        <div class="title-en">综合维保列表</div>
        <el-card class="box-card">
          <div class="table-container">
            <div class="button-container">
              <el-button @click="openColumnsDialog">表头设置</el-button>
              <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
            </div>
            <el-table :data="tableData" border stripe @selection-change="handleSelectionChange" ref="table"
              v-loading="loading">
              <el-table-column type="selection" width="55" align="center"></el-table-column>
              <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
              <el-table-column v-for="(column, index) in visibleColumns" :key="index" :prop="column.prop"
                :label="column.label" :width="column.width" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="
                    ['TicketStartDate', 'PlanStartDate', 'PlanEndDate', 'EndDate'].includes(
                      column.prop
                    )
                  ">{{
                    scope.row[column.prop]
                      ? $moment(scope.row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                      : '-'
                  }}</span>
                  <el-button v-else-if="column.prop === 'SubTicket'" type="text" size="small"
                    @click="handleSubTicketClick(scope.row)">查看子单</el-button>
                  <span v-else-if="column.prop === 'ToolsList'">
                    {{ scope.row.ToolsList == 'null' ? '-' : scope.row.ToolsList }}
                  </span>
                  <span v-else-if="column.prop === 'Item'">
                    {{ scope.row.Item == '[]' ? '-' : scope.row.Item }}
                  </span>

                  <span v-else>{{ scope.row[column.prop] || '-' }}</span>
                </template>
              </el-table-column>
            </el-table>

            <div class="pagination-container">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" />
            </div>
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="综合维保子单" name="subMaintenanceDetail">
        <subMaintenanceDetail v-if="activeTab === 'subMaintenanceDetail'" ref="subMaintenanceDetailRef" />
      </el-tab-pane>
      <el-tab-pane label="综合维保维修" name="maintenance-repair">
        <maintenance-repair v-if="activeTab === 'maintenance-repair'" ref="repairRef" />
      </el-tab-pane>

    </el-tabs>
    <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" :append-to-body="true" width="400px"
      :close-on-click-modal="false" custom-class="columns-dialog" :modal-append-to-body="false"
      :destroy-on-close="true">
      <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
        <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
          {{ column.label }}
        </el-checkbox>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="selectAllColumns">全选</el-button>
        <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
        <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="子单列表" :visible.sync="subTicketDialogVisible" width="90%"
      :before-close="handleSubTicketDialogClose">
      <!-- 子单搜索表单 -->
      <div class="search-container" style="margin-bottom: 20px;">
        <el-form :inline="true" :model="subTicketSearchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="时间范围">
                <el-date-picker
                  v-model="subTicketSearchForm.createTime"
                  type="daterange"
                  range-separator="-"
                  style="width: 100%"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  @change="handleSubTicketDateChange"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSubTicketSearch">点击查询</el-button>
                <el-button @click="handleSubTicketReset">重置</el-button>
                <el-button @click="handleSubTicketExport" :loading="subTicketExportLoading">{{
                  subTicketExportButtonText
                }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 子单表格 -->
      <el-table :data="subTicketList" border style="width: 100%" v-loading="loadings" max-height="500px"
        @selection-change="handleSubTicketSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="TicketId" label="工单号" width="150" />
        <el-table-column prop="MainTicketId" label="主流程工单号" width="150" />
        <el-table-column prop="StartTime" label="开始时间" width="200" />
        <el-table-column prop="ProcessTitle" label="标题" width="580" />
        <el-table-column prop="CampusName" label="园区名称" width="150" />
        <el-table-column prop="MozuName" label="模组名称" width="150" />
        <el-table-column prop="DeviceUid" label="设备uid" width="150" />
        <el-table-column prop="DeviceName" label="设备名称" width="150" />
        <el-table-column prop="DeviceNumber" label="设备编号" width="150" />
        <el-table-column prop="Professional" label="专业" width="150" />
        <el-table-column prop="DealUser" label="负责人" width="150" />
        <el-table-column prop="EndTime" label="结束时间" width="150" />
        <el-table-column prop="AbnormalCheckCount" label="异常计数" width="150" />
        <el-table-column prop="StatusLight" label="状态灯" width="150" />
        <el-table-column prop="MaintainSummary" label="维护总结" width="150" />
        <el-table-column prop="Confirm" label="确认结单状态" width="150" />
        <el-table-column prop="StandardTime" label="标准耗时" width="150" />
        <el-table-column prop="TimeConsuming" label="实际耗时" width="150" />
        <el-table-column prop="DevicetypesName" label="维护项目名称" width="150" />
        <el-table-column prop="ApplicationTypeName" label="应用类型" width="150" />
        <el-table-column prop="TicketStatus" label="工单状态" width="150" />
        <el-table-column prop="Maintainer" label="服务商" width="150" />
        <el-table-column prop="AuditResults" label="工单审核结果" width="150" />
        <el-table-column prop="AuditReason" label="审核原因" width="150" />
        <el-table-column prop="TimeOut" label="是否超时" width="150" />
        <el-table-column prop="CheckInTime" label="打卡时间" width="150" />
        <el-table-column prop="CheckInStatus" label="打卡状态" width="150" />
        <el-table-column prop="CheckInPlace" label="打卡地点" width="150" />
        <el-table-column prop="MaintenanceType" label="维护类型" width="150" />
        <el-table-column prop="MaintenanceCycle" label="维护周期" width="150" />
        <el-table-column prop="PTicketId" label="问题跟进单号" width="150" />
        <el-table-column prop="PInsId" label="问题跟进流程id" width="150" />
        <el-table-column prop="UploadStart" label="上传图片开始" width="150" show-overflow-tooltip />
        <el-table-column prop="UploadEnd" label="上传图片结束" width="150">
          <template slot-scope="scope">
            {{ scope.row.UploadEnd === 'null' ? '-' : scope.row.UploadEnd }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination @size-change="handleSubTicketSizeChange" @current-change="handleSubTicketCurrentChange"
          :current-page="subTicketCurrentPage" :page-sizes="[10, 20, 30, 50]" :page-size="subTicketPageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="subTicketTotal" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMaintenanceShow,
  getMaintenanceShowAll,
  getSubmaintenanceShow,
  getSubmaintenanceTkShow,
  getMaintenancefixShow,
  getShowExport,
} from '@/api/operation';
import MaintenanceRepair from './maintenance-repair.vue';
import subMaintenanceDetail from './subMaintenanceDetail.vue';
import { debounce } from 'lodash';
import * as XLSX from 'xlsx';

export default {
  components: {
    MaintenanceRepair,
    subMaintenanceDetail
  },

  name: 'Maintenance',
  data() {
    return {
      activeTab: 'maintenance',
      debouncedExport: null,
      tableData: [
        {
          AdminComments: '',
          AvgTimeConsuming: 1.57,
          CampusName: '清远-清城',
          ChangeId: '',
          DeviceList:
            '["【PAL102房间-低压电力方仓-11-变压器-01】QY-QC-BD7-PAL102-LVPM-11-TR-01", "【PAL102房间-低压电力方仓-09-变压器-01】QY-QC-BD7-PAL102-LVPM-09-TR-01", "【PAL102房间-低压电力方仓-10-变压器-01】QY-QC-BD7-PAL102-LVPM-10-TR-01", "【PAL102房间-低压电力方仓-13-变压器-01】QY-QC-BD7-PAL102-LVPM-13-TR-01", "【PAL102房间-低压电力方仓-15-变压器-01】QY-QC-BD7-PAL102-LVPM-15-TR-01", "【PAL102房间-低压电力方仓-12-变压器-01】QY-QC-BD7-PAL102-LVPM-12-TR-01", "【PAL102房间-低压电力方仓-14-变压器-01】QY-QC-BD7-PAL102-LVPM-14-TR-01", "【PAL102房间-低压电力方仓-16-变压器-01】QY-QC-BD7-PAL102-LVPM-16-TR-01"]',
          DevicetypesName: '变压器',
          EndDate: '2025-06-09',
          FmcReject: '否',
          FmcUser: 'v_yueqzhang(张月桥)',
          Id: '30700000075925',
          Item: '[]',
          MOP: '',
          MadminReview: '合格',
          Maintainer: '鸿云',
          MaintenanceCycle: '季度',
          MaintenanceType: '预防性维护',
          MozuName: '清远清城模组72',
          OncePass: '是',
          Operator: 'Fo_邢广阔',
          PMEngineer: 'yangyi',
          PMPhone: '',
          PlanEndDate: '2025-06-15',
          PlanStartDate: '2025-06-09',
          ProcessTitle: '清远清城模组72-变压器-季度预防性维护计划',
          Professional: '配电',
          ReCheckList:
            '{"re_check1_1": "是", "re_check1_2": "是", "re_check1_3": "是", "re_check2_1": "是", "re_check2_2": "是", "re_check2_3": "是", "re_check2_4": "是", "re_check3_1": null}',
          ReasonForMadmin: '',
          RegionName: '华南',
          SOP: '',
          StandardTime: 0.8,
          StatusLight: '绿',
          SupplierTimes: 12.54,
          TicketId: '20250602010570',
          TicketStartDate: '2025-06-02',
          TicketStatus: '已完成',
          ToChange: '2',
          ToMaintainer: '服务商',
          ToolsList: 'null',
          UnqualifiedType: '',
          UseMop: '是',
          WorkersCount: 2,
        },
      ],
      loadings: false,
      searchForm: {
        TicketId: '',
        RegionName: '',
        CampusName: '',
        MozuName: '',
        ProcessTitle: '',
        MaintenanceType: '',
        Professional: '',
        DevicetypesName: '',
        Operator: '',
        Maintainer: '',
        PMEngineer: '',
        TicketStatus: '',
        createTime: [],
        start_time: '',
        end_time: '',
        abnormal_situation: '',
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showColumnsDialog: false,
      selectedColumns: [
        'TicketId',
        'SubTicket',
        'RegionName',
        'CampusName',
        'MozuName',
        'TicketStartDate',
        'PlanStartDate',
        'PlanEndDate',
        'ProcessTitle',
        'MaintenanceType',
        'MaintenanceCycle',
        'Professional',
        'DeviceList',
        'DevicetypesName',
        'Operator',
        'Maintainer',
        'PMEngineer',
        'StandardTime',
        'AvgTimeConsuming',
        'SupplierTimes',
        'WorkersCount',
        'ToMaintainer',
        'ToolsList',
        'SOP',
        'MOP',
        'UseMop',
        'Item',
        'ReCheckList',
        'OncePass',
        'MadminReview',
        'ReasonForMadmin',
        'FmcReject',
        'FmcUser',
        'ChangeId',
        'ToChange',
        'UnqualifiedType',
        'StatusLight',
        'TicketStatus',
        'EndDate',
        'AdminComments',
      ],
      defaultSelectedColumns: [
        'TicketId',
        'SubTicket',
        'RegionName',
        'CampusName',
        'MozuName',
        'TicketStartDate',
        'PlanStartDate',
        'PlanEndDate',
        'ProcessTitle',
        'MaintenanceType',
        'MaintenanceCycle',
        'Professional',
        'DeviceList',
        'DevicetypesName',
        'Operator',
        'Maintainer',
        'PMEngineer',
        'StandardTime',
        'AvgTimeConsuming',
        'SupplierTimes',
        'WorkersCount',
        'ToMaintainer',
        'ToolsList',
        'SOP',
        'MOP',
        'UseMop',
        'Item',
        'ReCheckList',
        'OncePass',
        'MadminReview',
        'ReasonForMadmin',
        'FmcReject',
        'FmcUser',
        'ChangeId',
        'ToChange',
        'UnqualifiedType',
        'StatusLight',
        'TicketStatus',
        'EndDate',
        'AdminComments',
      ],
      columns: [
        { prop: 'TicketId', label: '工单ID', width: 150 },
        { prop: 'SubTicket', label: '子单列表', width: 150 },
        { prop: 'RegionName', label: '区域', width: 150 },
        { prop: 'CampusName', label: '园区', width: 150 },
        { prop: 'MozuName', label: '模组', width: 150 },
        { prop: 'TicketStartDate', label: '工单开始日期', width: 150 },
        { prop: 'PlanStartDate', label: '计划开始日期', width: 150 },
        { prop: 'PlanEndDate', label: '计划结束日期', width: 150 },
        { prop: 'ProcessTitle', label: '流程标题', width: 150 },
        { prop: 'MaintenanceType', label: '维护类型', width: 150 },
        { prop: 'MaintenanceCycle', label: '维护周期', width: 150 },
        { prop: 'Professional', label: '专业', width: 150 },
        { prop: 'DeviceList', label: '设备列表', width: 150 },
        { prop: 'DevicetypesName', label: '设备类型名称', width: 150 },
        { prop: 'Operator', label: '操作员', width: 150 },
        { prop: 'Maintainer', label: '维护商', width: 150 },
        { prop: 'PMEngineer', label: 'PM工程师', width: 150 },
        { prop: 'StandardTime', label: '标准时间', width: 150 },
        { prop: 'AvgTimeConsuming', label: '平均耗时', width: 150 },
        { prop: 'SupplierTimes', label: '服务商统计总耗时', width: 150 },
        { prop: 'WorkersCount', label: '工人数量', width: 150 },
        { prop: 'ToMaintainer', label: '维护商类型', width: 150 },
        { prop: 'ToolsList', label: '工具列表', width: 150 },
        { prop: 'SOP', label: '标准操作程序', width: 150 },
        { prop: 'MOP', label: '作业指导书', width: 150 },
        { prop: 'UseMop', label: '是否使用MOP', width: 150 },
        { prop: 'Item', label: '项目', width: 150 },
        { prop: 'ReCheckList', label: '复核清单', width: 150 },
        { prop: 'OncePass', label: '是否一次性通过', width: 150 },
        { prop: 'MadminReview', label: '管理员审核结果', width: 150 },
        { prop: 'ReasonForMadmin', label: '管理员审核不通过原因', width: 150 },
        { prop: 'FmcReject', label: 'FMC驳回', width: 150 },
        { prop: 'FmcUser', label: 'FMC用户', width: 150 },
        { prop: 'ChangeId', label: '变更ID', width: 150 },
        { prop: 'ToChange', label: '变更次数', width: 150 },
        { prop: 'UnqualifiedType', label: '不合格项', width: 150 },
        { prop: 'StatusLight', label: '状态指示灯', width: 150 },
        { prop: 'TicketStatus', label: '工单状态', width: 150 },
        { prop: 'EndDate', label: '结束日期', width: 150 },
        { prop: 'AdminComments', label: '管理员评论', width: 150 },
      ],
      visibleColumns: [],
      selectedRows: [],
      loading: false,
      subTicketDialogVisible: false,
      subTicketList: [],
      subTicketCurrentPage: 1,
      subTicketPageSize: 10,
      subTicketTotal: 0,
      subTicketSearchForm: {
        TicketId: '',
        StartTime: '',
        EndTime: '',
        ProcessTitle: '',
        CampusName: '',
        MozuName: '',
        DeviceName: '',
        Professional: '',
        DealUser: '',
        TicketStatus: '',
        createTime: [],
        start_time: '',
        end_time: '',
      },
      subTicketExportLoading: false,
      subTicketSelectedRows: [],
    };
  },
  created() {
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    // 设置默认时间范围为当前自然月
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    this.searchForm.createTime = [
      this.$moment(firstDay).format('YYYY-MM-DD'),
      this.$moment(lastDay).format('YYYY-MM-DD'),
    ];
    this.searchForm.start_time = this.$moment(firstDay).format('YYYY-MM-DD HH:mm:ss');
    this.searchForm.end_time = this.$moment(lastDay).format('YYYY-MM-DD HH:mm:ss');
    this.fetchData();
    // 创建防抖后的导出函数
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    handleTabClick(tab) {
      // 重置分页到第一页
      this.currentPage = 1;
      this.activeTab = tab.name;

      // 切换标签页时清空工单ID搜索条件
      this.searchForm.TicketId = '';

      // 根据选项卡名称决定如何处理
      if (tab.name === 'subMaintenanceDetail') {
        // 如果切换到子单选项卡，调用子组件的方法
        this.$nextTick(() => {
          if (this.$refs.subMaintenanceDetailRef) {
            // 清除可能存在的旧数据和加载状态
            this.$refs.subMaintenanceDetailRef.tableData = [];
            this.$refs.subMaintenanceDetailRef.total = 0;

            this.$refs.subMaintenanceDetailRef.fetchData({
              page: 1,
              size: this.$refs.subMaintenanceDetailRef.pageSize,
              start_time: this.searchForm.start_time,
              end_time: this.searchForm.end_time,
              export: "0",
              // 添加其他搜索参数
              TicketId: this.searchForm.TicketId || null,
              CampusName: this.searchForm.CampusName || null,
              abnormal_situation: this.searchForm.abnormal_situation
            });
          }
        });
      } else if (tab.name === 'maintenance-repair') {
        // 如果切换到维修选项卡，调用维修组件的方法
        this.$nextTick(() => {
          if (this.$refs.repairRef) {
            // 清除可能存在的旧数据和加载状态
            this.$refs.repairRef.tableData = [];
            this.$refs.repairRef.total = 0;

            this.$refs.repairRef.fetchData({
              page: 1,
              size: this.$refs.repairRef.pageSize,
              start_time: this.searchForm.start_time,
              end_time: this.searchForm.end_time,
              export: "0",
              // 添加其他搜索参数
              TicketId: this.searchForm.TicketId || null,
              CampusName: this.searchForm.CampusName || null,
              abnormal_situation: this.searchForm.abnormal_situation
            });
          }
        });
      } else {
        // 默认为主单选项卡，调用主数据获取方法
        this.fetchData();
      }
    },

    async fetchData() {
      this.loading = true;
      console.log("标签名称", this.activeTab)
      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize,
          ...this.searchForm,
          TicketId: this.searchForm.TicketId || null,
          export: "0",
          start_time: this.searchForm.start_time,
          end_time: this.searchForm.end_time
            ? this.$moment(this.searchForm.end_time).format('YYYY-MM-DD 23:59:59')
            : null,
          abnormal_situation: this.searchForm.abnormal_situation,
        };

        let response;
        if (this.activeTab === 'maintenance') {
          response = await getMaintenanceShow(params);
        } else if (this.activeTab === 'subMaintenanceDetail') {
          // 如果当前在子单页面，应该调用子组件的fetchData方法
          if (this.$refs.subMaintenanceDetailRef) {
            this.$refs.subMaintenanceDetailRef.fetchData(params);
          }
          return; // 提前返回，避免重复处理
        } else if (this.activeTab === 'maintenance-repair') {
          // 如果当前在维修页面，应该调用维修组件的fetchData方法
          if (this.$refs.repairRef) {
            this.$refs.repairRef.fetchData(params);
          }
          return; // 提前返回，避免重复处理
        }

        if (response && response.data) {
          this.tableData = response.data.data.data || [];
          this.total = response.data.data.count || 0;
        }
      } catch (error) {
        console.error('获取数据失败：', error);
        let errorMessage = '获取数据失败';
        if (error.response?.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      // 保持当前标签页不变，重新获取数据
      this.fetchData();
    },
    handleReset() {
      // 重置所有搜索条件
      this.searchForm = {
        TicketId: '',
        CampusName: '',
        MozuName: '',
        abnormal_situation: '',
        TaskName: '',
        InspType: '',
        PlanStartTime: '',
        RealStartTime: '',
        RealEndTime: '',
        InspStatus: '',
        CreateTime: '',
        UpdateTime: '',
        start_time: null,
        end_time: null,
      };
      // 重置为当前自然月
      const now = new Date();
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      this.searchForm.createTime = [
        this.$moment(firstDay).format('YYYY-MM-DD'),
        this.$moment(lastDay).format('YYYY-MM-DD'),
      ];
      this.searchForm.start_time = this.$moment(firstDay).format('YYYY-MM-DD HH:mm:ss');
      this.searchForm.end_time = this.$moment(lastDay).format('YYYY-MM-DD HH:mm:ss');
      this.currentPage = 1;
      this.fetchData();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    handleDateChange(dates) {
      if (dates) {
        this.searchForm.start_time = this.$moment(dates[0]).format('YYYY-MM-DD HH:mm:ss');
        this.searchForm.end_time = this.$moment(dates[1]).format('YYYY-MM-DD 23:59:59');
      } else {
        // 如果清空日期，重置为当前自然月
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        this.searchForm.createTime = [
          this.$moment(firstDay).format('YYYY-MM-DD'),
          this.$moment(lastDay).format('YYYY-MM-DD'),
        ];
        this.searchForm.start_time = this.$moment(firstDay).format('YYYY-MM-DD HH:mm:ss');
        this.searchForm.end_time = this.$moment(lastDay).format('YYYY-MM-DD 23:59:59');
      }
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          this.loading = true;
          // TODO: 替换为实际的导出API
          const response = await getMaintenanceShowAll({
            ...this.searchForm,
            TicketId: this.searchForm.TicketId || null,
            start_time: this.searchForm.start_time,
            end_time: this.searchForm.end_time,
            abnormal_situation: this.searchForm.abnormal_situation,
          });

          if (response.data) {
            this.loading = false;
            const allData = response.data.data.data || [];
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.visibleColumns.forEach((column) => {
                if (column.prop !== 'operation') {
                  let value = row[column.prop];
                  if (
                    [
                      'CreateTime',
                      'UpdateTime',
                      'PlanStartTime',
                      'RealStartTime',
                      'RealEndTime',
                    ].includes(column.prop)
                  ) {
                    value = value ? this.$moment(value).format('YYYY-MM-DD HH:mm:ss') : '-';
                  }
                  rowData[column.label] = value || '-';
                }
              });
              return rowData;
            });

            const worksheet = XLSX.utils.json_to_sheet(worksheetData);

            const colWidths = {};
            this.visibleColumns.forEach((column, index) => {
              const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, '综合维保列表');

            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `综合维保列表_${timestamp}.xlsx`;

            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } else {
          const worksheetData = this.selectedRows.map((row) => {
            const rowData = {};
            this.visibleColumns.forEach((column) => {
              if (column.prop !== 'operation') {
                let value = row[column.prop];
                if (
                  [
                    'CreateTime',
                    'UpdateTime',
                    'PlanStartTime',
                    'RealStartTime',
                    'RealEndTime',
                  ].includes(column.prop)
                ) {
                  value = value ? this.$moment(value).format('YYYY-MM-DD HH:mm:ss') : '-';
                }
                rowData[column.label] = value || '-';
              }
            });
            return rowData;
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '综合维保列表');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `综合维保列表_${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
    handleSubTicketSizeChange(val) {
      this.subTicketPageSize = val;
      this.handleSubTicketClick(this.currentRow);
    },
    handleSubTicketCurrentChange(val) {
      this.subTicketCurrentPage = val;
      this.handleSubTicketClick(this.currentRow);
    },
    async handleSubTicketClick(row) {
      try {
        this.loading = true;
        this.loadings = true;
        this.currentRow = row;
        const params = {
          tkid: row.TicketId,
          page: this.subTicketCurrentPage,
          size: this.subTicketPageSize,
          ...Object.fromEntries(
            Object.entries(this.subTicketSearchForm).filter(
              ([_, value]) => value !== '' && value !== null && value !== undefined
            )
          ),
        };
        const res = await getSubmaintenanceShow(params);
        if (res.data.code === 200) {
          this.subTicketList = res.data.data.data || [];
          this.subTicketTotal = res.data.data.count || 0;
        } else {
          this.$message.error(res.msg || '获取子单列表失败');
        }
      } catch (error) {
        console.error('获取子单列表出错:', error);
        this.$message.error('获取子单列表失败');
      } finally {
        this.loading = false;
        this.loadings = false;
        this.subTicketDialogVisible = true;
      }
    },
    handleSubTicketDialogClose() {
      this.subTicketDialogVisible = false;
      this.subTicketList = [];
      this.subTicketSelectedRows = [];
      // 重置子单搜索表单
      this.subTicketSearchForm = {
        TicketId: '',
        StartTime: '',
        EndTime: '',
        ProcessTitle: '',
        CampusName: '',
        MozuName: '',
        DeviceName: '',
        Professional: '',
        DealUser: '',
        TicketStatus: '',
        createTime: [],
        start_time: '',
        end_time: '',
      };
    },
    handleSubTicketSelectionChange(selection) {
      this.subTicketSelectedRows = selection;
    },
    handleSubTicketDateChange(dates) {
      if (dates) {
        this.subTicketSearchForm.start_time = this.$moment(dates[0]).format('YYYY-MM-DD HH:mm:ss');
        this.subTicketSearchForm.end_time = this.$moment(dates[1]).format('YYYY-MM-DD 23:59:59');
      } else {
        this.subTicketSearchForm.start_time = '';
        this.subTicketSearchForm.end_time = '';
      }
    },
    handleSubTicketSearch() {
      this.subTicketCurrentPage = 1;
      this.handleSubTicketClick(this.currentRow);
    },
    handleSubTicketReset() {
      this.subTicketSearchForm = {
        TicketId: '',
        StartTime: '',
        EndTime: '',
        ProcessTitle: '',
        CampusName: '',
        MozuName: '',
        DeviceName: '',
        Professional: '',
        DealUser: '',
        TicketStatus: '',
        createTime: [],
        start_time: '',
        end_time: '',
      };
      this.subTicketCurrentPage = 1;
      this.handleSubTicketClick(this.currentRow);
    },
    async handleSubTicketExport() {
      this.subTicketExportLoading = true;
      try {
        let exportData = [];
        if (this.subTicketSelectedRows.length === 0) {
          // 导出全部数据 - 获取所有页的数据
          const response = await getShowExport({
            tkid: this.currentRow.TicketId,
            page: 1,
            size: this.subTicketTotal, // 获取所有数据
            ...Object.fromEntries(
              Object.entries(this.subTicketSearchForm).filter(
                ([_, value]) => value !== '' && value !== null && value !== undefined
              )
            ),
          });
          if (response.data.code === 200) {
            exportData = response.data.data.data || [];
          }
        } else {
          // 导出选中数据
          exportData = this.subTicketSelectedRows;
        }

        if (exportData.length === 0) {
          this.$message.warning('没有数据可导出');
          return;
        }

        // 定义子单列表的列配置
        const subTicketColumns = [
          { prop: 'TicketId', label: '工单号' },
          { prop: 'MainTicketId', label: '主流程工单号' },
          { prop: 'StartTime', label: '开始时间' },
          { prop: 'ProcessTitle', label: '标题' },
          { prop: 'CampusName', label: '园区名称' },
          { prop: 'MozuName', label: '模组名称' },
          { prop: 'DeviceUid', label: '设备uid' },
          { prop: 'DeviceName', label: '设备名称' },
          { prop: 'DeviceNumber', label: '设备编号' },
          { prop: 'Professional', label: '专业' },
          { prop: 'DealUser', label: '负责人' },
          { prop: 'EndTime', label: '结束时间' },
          { prop: 'AbnormalCheckCount', label: '异常计数' },
          { prop: 'StatusLight', label: '状态灯' },
          { prop: 'MaintainSummary', label: '维护总结' },
          { prop: 'Confirm', label: '确认结单状态' },
          { prop: 'StandardTime', label: '标准耗时' },
          { prop: 'TimeConsuming', label: '实际耗时' },
          { prop: 'DevicetypesName', label: '维护项目名称' },
          { prop: 'ApplicationTypeName', label: '应用类型' },
          { prop: 'TicketStatus', label: '工单状态' },
          { prop: 'Maintainer', label: '服务商' },
          { prop: 'AuditResults', label: '工单审核结果' },
          { prop: 'AuditReason', label: '审核原因' },
          { prop: 'TimeOut', label: '是否超时' },
          { prop: 'CheckInTime', label: '打卡时间' },
          { prop: 'CheckInStatus', label: '打卡状态' },
          { prop: 'CheckInPlace', label: '打卡地点' },
          { prop: 'MaintenanceType', label: '维护类型' },
          { prop: 'MaintenanceCycle', label: '维护周期' },
          { prop: 'PTicketId', label: '问题跟进单号' },
          { prop: 'PInsId', label: '问题跟进流程id' },
          { prop: 'UploadStart', label: '上传图片开始' },
          { prop: 'UploadEnd', label: '上传图片结束' },
        ];

        const worksheetData = exportData.map((row) => {
          const rowData = {};
          subTicketColumns.forEach((column) => {
            let value = row[column.prop];
            if (['StartTime', 'EndTime', 'CheckInTime'].includes(column.prop)) {
              value = value ? this.$moment(value).format('YYYY-MM-DD HH:mm:ss') : '-';
            }
            if (column.prop === 'UploadEnd') {
              value = value === 'null' ? '-' : value;
            }
            rowData[column.label] = value || '-';
          });
          return rowData;
        });

        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '子单列表');

        const filename = `子单列表_${this.$moment().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;
        XLSX.writeFile(workbook, filename);
        this.$message.success('导出成功');
      } catch (error) {
        console.error('子单导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.subTicketExportLoading = false;
      }
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
    subTicketExportButtonText() {
      return this.subTicketSelectedRows.length > 0
        ? `导出已选(${this.subTicketSelectedRows.length})`
        : '导出全部';
    },
  },
  watch: {
    selectedColumns(val) {
      this.selectAll = val.length === this.columns.length;
      this.isIndeterminate = val.length > 0 && val.length < this.columns.length;
    },
  },
};
</script>

<style scoped>

.container {
  padding: 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button+.el-button {
  margin-left: 8px;
}

/* PO单号链接样式 */
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}

::v-deep .el-tabs__nav-wrap::after {
  height: 0px !important;
}
</style>
